import { useState } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import Loader from '../components/Loader';
import FormContainer from '../components/FormContainer';
import Meta from '../components/Meta';
import { useSendCommissionMutation } from '../slices/contactApiSlice';
import NewsletterSignup from '../components/NewsletterSignup';
import { toast } from 'react-toastify';

const CommissionsScreen = () => {
  // Commission request form
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [budget, setBudget] = useState('');
  const [message, setMessage] = useState('');

  const [sendCommission, { isLoading: isSending }] =
    useSendCommissionMutation();

  const commissionHandler = async (e) => {
    e.preventDefault();
    try {
      const res = await sendCommission({
        name,
        email,
        budget,
        message,
      }).unwrap();
      toast.success(res?.message || 'Commission request sent');
      setName('');
      setEmail('');
      setBudget('');
      setMessage('');
    } catch (error) {
      toast.error(error?.data?.message || error.error);
    }
  };

  return (
    <FormContainer>
      <Meta title="Commissions | Limbism" />

      <h1>Commission an Artwork</h1>
      <p>
        Interested in a custom piece? Tell me a little about what you have in
        mind and I will get back to you.
      </p>
      <Form onSubmit={commissionHandler}>
        <Form.Group className="my-3" controlId="commissionName">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <Form.Group className="my-3" controlId="commissionEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <Form.Group className="my-3" controlId="commissionBudget">
          <Form.Label>Budget (optional)</Form.Label>
          <Form.Control
            type="text"
            placeholder="e.g. $500 - $1000"
            value={budget}
            onChange={(e) => setBudget(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <Form.Group className="my-3" controlId="commissionMessage">
          <Form.Label>Tell me about your idea</Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            placeholder="Size, subject, timeline, where it will live..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <Button
          type="submit"
          variant="primary"
          className="mt-2"
          disabled={isSending}
        >
          Send Request
        </Button>
        {isSending && <Loader />}
      </Form>

      <Row className="py-3">
        <Col></Col>
      </Row>
    </FormContainer>
  );
};

export default CommissionsScreen;
